import BlogHomepageContent, {
  BlogFilterCategory,
} from "components/blog/BlogHomepageContent";
import BlogHomepageHeader from "components/blog/BlogHomepageHeader";
import { useMemo } from "react";
import {
  AllBlogSectionsQuery,
  ArticlesBySectionQuery,
  BlogPageQuery,
} from "services/datocms/generated";

type BlogPageContentProps = {
  sections: AllBlogSectionsQuery["allBlogSections"];
  selectedSection?: AllBlogSectionsQuery["allBlogSections"][number] | null;
  category?: string;
  pageData?: BlogPageQuery["blogPage"] | null;
  articles?: ArticlesBySectionQuery["allArticles"];
};

const BlogPageContent = ({
  sections,
  pageData,
  selectedSection,
  articles,
}: BlogPageContentProps) => {
  const filteredCategories = useMemo(() => {
    return sections?.reduce((acc, s) => {
      if (s?.shouldAppearAsCategoryFilter) {
        acc.push({ slug: s.slug ?? "", filterText: s.filterText ?? "" });
      }
      return acc;
    }, [] as BlogFilterCategory[]);
  }, [sections]);

  return (
    <>
      <BlogHomepageHeader
        selectedCategory={selectedSection}
        pageTitle={pageData?.pageTitle ?? ""}
        newsletterData={pageData?.topNewsletter}
        blogHomepageHero={pageData?.heroVisual?.responsiveImage}
      />
      <BlogHomepageContent
        sections={selectedSection ? [selectedSection] : sections}
        selectedCategory={selectedSection}
        filteredCategories={filteredCategories}
        articles={articles}
      />
    </>
  );
};

export default BlogPageContent;
